import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { UserFile } from 'src/app/model/user-file';
import { AppState } from 'src/app/store/app.reducer';
import * as UserFileActions from 'src/app/store//user-file/user-file.actions';
import { EUserCompatLevel } from 'src/app/conf/board-users';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { selectImportLoading, selectImportStarted, selectLoading, selectTemporaryListCompatLevel } from 'src/app/store/user-file/user-file.selector';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';


@Component({
	templateUrl: './import-file-dialog.component.html',
})

export class ImportFileDialogComponent implements OnInit, OnDestroy {

	fileCompatibility: number[];

	level$: Observable<number[] | undefined>;
	levelSub: Subscription;

	started$: Observable<boolean | undefined>;
	startedSub: Subscription;

	loading$: Observable<boolean | undefined>;
	loadingSub: Subscription;

	boarduserFile: UserFile;

	loading: boolean;

	// Design
	screenWidth: number;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		if (config.data !== undefined && config.data.boarduserFile !== undefined) {
			this.boarduserFile = config.data.boarduserFile;
		}
		this.initSelectors();
	}

	ngOnInit(): void {
		this.checkBoardusersListCompat();
		this.subscribeAll();
		this.onResize();
	}

	checkBoardusersListCompat(): void {
		this.store.dispatch(UserFileActions.checkBoardusersListCompat({ exportId: this.boarduserFile.Id }));
	}

	initSelectors(): void {
		this.level$ = this.store.select(selectTemporaryListCompatLevel);
		this.started$ = this.store.select(selectImportStarted);
		this.loading$ = this.store.select(selectImportLoading);
	}

	subscribeAll(): void {
		this.levelSub = this.level$?.subscribe(
			(level) => {
				this.fileCompatibility = level;
			}
		);
		this.startedSub = this.started$?.pipe(filter(started => !!started)).subscribe(
			() => {
				this.closeDialog();
			}
		);
		this.loadingSub = this.loading$?.subscribe(
			(loading) => {
				this.loading = loading;
			}
		)
	}

	closeDialog(): void {
		this.ref.close();
	}

	ngOnDestroy(): void {
		this.levelSub?.unsubscribe();
		this.startedSub?.unsubscribe();
	}

	unfitToImport(): boolean {
		return this.fileCompatibility.includes(EUserCompatLevel.Unknown) ||
			this.fileCompatibility.includes(EUserCompatLevel.Incompatible);
	}

	compatible(): boolean {
		return this.fileCompatibility.includes(EUserCompatLevel.Compatible) &&
			!this.fileCompatibility.includes(EUserCompatLevel.FixControlItem);
	}

	almostCompat(): boolean {
		return this.fileCompatibility.includes(EUserCompatLevel.FixControlItem);
	}

	incompatible(): boolean {
		return this.fileCompatibility.includes(EUserCompatLevel.Incompatible);
	}

	unknown(): boolean {
		return this.fileCompatibility.includes(EUserCompatLevel.Unknown);
	}

	submit(): void {
		this.store.dispatch(UserFileActions.importBoardusersExport({ exportId: this.boarduserFile.Id }));
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}
